module.exports = __webpack_public_path__ + "img/skills-lf-ama-2.fc50a833.png";